export const REPORT_INVOKE_ACTION = '/DXXRDV';